import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FocusableOption, FocusOrigin, Highlightable } from '@angular/cdk/a11y';
import { FilterSelectOption } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-select.model';

@Component({
  standalone: false,
  selector: 'nimbus-nimbus-filter-select-list-item',
  templateUrl: './nimbus-filter-select-list-item.component.html',
  styleUrls: ['./nimbus-filter-select-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterSelectListItemComponent implements FocusableOption, Highlightable {
  @Input() public option: FilterSelectOption;
  @Input() public selected: boolean;
  @Output() public filterSelect: EventEmitter<{ selected: boolean; option: FilterSelectOption }> = new EventEmitter();
  @ViewChild('filterItem', { static: true }) public item: ElementRef<HTMLButtonElement>;
  private readonly activeClass = 'nimbus-select-filter-item-focus';
  private readonly clickedClass = 'nimbus-select-filter-item-active';
  public constructor(private readonly renderer: Renderer2) {}

  public focus(origin?: FocusOrigin): void {
    this.item.nativeElement.focus();
  }

  public setActiveStyles(): void {
    this.renderer.addClass(this.item.nativeElement, this.activeClass);
  }

  public setInactiveStyles(): void {
    this.renderer.removeClass(this.item.nativeElement, this.activeClass);
  }

  public setClickStyle(): void {
    this.renderer.addClass(this.item.nativeElement, this.clickedClass);
  }

  public onClick() {
    this.filterSelect.emit({ selected: !this.selected, option: this.option });
  }

  public getLabel?(): string {
    return this.option.name;
  }
}
